import { useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { resolveRedirect } from "@/lib/redirects";

/**
 * Aplica os redirects 301 (mapa estático) antes de qualquer rota renderizar.
 * Preserva query string e hash.
 */
export function RedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const target = resolveRedirect(location.pathname);
    if (target) {
      if (/^https?:\/\//i.test(target)) {
        window.location.replace(target);
        return;
      }
      navigate(`${target}${location.search}${location.hash}`, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
}

export default RedirectHandler;
